export const DELETE_ACTION = "DeleteItemAction"

export const findPrimaryButtons = (
    buttons: ContextMenu.Button[],
): ContextMenu.Button[] => buttons.filter((button) => !button.inOptionalMenu)

export const findOptionalStandardButtons = (
    buttons: ContextMenu.Button[],
): ContextMenu.Button[] =>
    buttons.filter(
        (button) =>
            button.inOptionalMenu &&
            button.id != DELETE_ACTION &&
            !button.isCustom,
    )

export const findOptionalCustomButtons = (
    buttons: ContextMenu.Button[],
): ContextMenu.Button[] =>
    buttons.filter(
        (button) =>
            button.inOptionalMenu &&
            button.id != DELETE_ACTION &&
            button.isCustom,
    )

export const findDeleteButton = (
    buttons: ContextMenu.Button[],
): ContextMenu.Button | null =>
    buttons.find((button) => button.id === DELETE_ACTION) ?? null
